// extracted by mini-css-extract-plugin
export default {"container":"Photos_container__MA5Ye","yearSection":"Photos_yearSection__Imujb","workshopSection":"Photos_workshopSection__q+orG"};